import { Apartment, Bolt, Construction, Home, Receipt, Shower, Wifi } from "@mui/icons-material";

import { Dev } from "./consoleUtil";

import { ModalType, UserType } from "../../types/common";

export const UtilComponents = {
  BillIcon: ({ ...props }) => {
    const { name, ...other } = props;

    switch (name) {
      case "ap":
        return <Apartment {...other} />;
      case "home":
        return <Home {...other} />;
      case "fix":
        return <Construction {...other} />;
      case "internet":
        return <Wifi {...other} />;
      case "water":
        return <Shower {...other} />;
      case "light":
        return <Bolt {...other} />;
      default:
        return <Receipt {...other} />;
    }
  },

  copyToClipboard: async (
    pushAlert: (alert: ModalType) => void,
    text: string,
    successMessage: string = "Copiado para a área de transferência!"
  ) => {
    try {
      await navigator.clipboard.writeText(text);

      pushAlert({
        type: "info",
        message: successMessage,
      });
    } catch (error) {
      console.log(...new Dev("copyToClipboard", error).Error());

      pushAlert({
        type: "info",
        message: "Erro ao copiar para a área de transferência!",
      });
    }
  },

  monthMap: (number: string | number, isShort: boolean = false) => {
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    const month = months[parseInt(String(number))];
    return isShort ? month.slice(0, 3) : month;
  },

  getRatingColor: (rawGrade: number, rawDeviation: number) => {
    const grade = parseFloat(String(rawGrade) || "0");
    const deviation = parseFloat(String(rawDeviation) || "0");

    if (grade >= 9.2 && deviation <= 1.9) {
      return "#28a745";
    } else if (grade >= 8.2 && deviation <= 2.2) {
      return "#ffc107";
    }
    return "#dc3545";
  },

  toPrice: (value: string | number, withSign: boolean = true) => {
    return `R$ ${parseFloat(String(value)).toFixed(2).replace(".", ",")}`;
  },

  isStaff: (state: UserType | null) => {
    return UtilComponents.isAdmin(state) || state?.type === "staff";
  },

  isAdmin: (state: UserType | null) => {
    return state?.type === "admin";
  },
};
